import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col, Tabs} from 'react-bootstrap'
import {mediaQuery} from '../../core/browser'
import extract from '../../core/extract'
import {connectForm, nodeHasValue} from '../../core/redux/form'
import SearchBar from '../../core/components/SearchBar'
import TypeaheadBar, {matcher} from '../../core/components/TypeaheadBar'
import Tags from '../../core/components/Tags'
import {Criteria} from '../models'
import {DEFAULT_PATRIMONY_QUERY, CRITERIA_UPDATED, loadPatrimonyStream} from '../actions'
import i18n from '../i18n'
import style from './PatrimonySearchBar.less'

function isActive(source, identify) {
    return (item) => {
        const id = identify(item)
        return source.find((i) => identify(i) == id) != null
    }
}

class PatrimonySearchBar extends Component {
    static propTypes = {
    }

    _search(event) {
        const {dispatch, criteria, location} = this.props

        if (event) {
            event.preventDefault()
        }

        return dispatch(loadPatrimonyStream({...DEFAULT_PATRIMONY_QUERY, ...criteria})).then(() => {
            if (location.pathname != 'patrimonies') {
                return dispatch(push('/patrimonies'))
            }
        })
    }

    _searchOnKeyPress(event) {
        if (event.key == 'Enter') {
            const {dispatch, criteria, location} = this.props
            
            return dispatch(loadPatrimonyStream({...DEFAULT_PATRIMONY_QUERY, ...criteria})).then(() => {
                if (location.pathname != 'patrimonies') {
                    return dispatch(push('/patrimonies'))
                }
            })
        }
    }

    render() {
        const {dispatch, form, criteria, aggregations, location} = this.props

        const agencySource = matcher({
            source: aggregations.agencies,
            identify: (a) => a.label
        })

        const footer = nodeHasValue(form.agencyUids) && (
            <div>
                <Tags
                    label={i18n.agency + ' :'}
                    labelClassName='col-sm-2'
                    wrapperClassName='col-sm-10'
                    display={(a) => a.label}
                    active={isActive(aggregations.agencies, (a) => a.value)}
                    {...form.agencyUids()} />
            </div>
        ) || null

        return (
        	<SearchBar
                footer={footer}
                placeholder={extract(i18n.searchStream, mediaQuery())}
                onClick={(e) => this._search(e)}
                onKeyPress={(e) => this._searchOnKeyPress(e)}
                {...form.fullText()}>
                <Row>
                    <Col sm={12}>
                        <div className={style.content}>
                            <TypeaheadBar split
                                source={agencySource}
                                identify={(a) => a.value}
                                display={(a) => a.label + ' (' + a.count + ')'}
                                placeholder={extract(i18n.searchAgency, mediaQuery())}
                                {...form.agencyUids()} />
                        </div>
                    </Col>
                </Row>
        	</SearchBar>
        )
    }
}

PatrimonySearchBar = connectForm({
    target: 'criteria',
    schema: Criteria.schema,
    action: CRITERIA_UPDATED
})(PatrimonySearchBar)

PatrimonySearchBar = connect((state) => ({
    location: state.router.location,
    criteria: state.patrimony.criteria,
    aggregations: state.patrimony.aggregations
}))(PatrimonySearchBar)

export default PatrimonySearchBar


// WEBPACK FOOTER //
// ./lib/patrimony/components/PatrimonySearchBar.js